define( function() {
	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/ajax/var/location.js
// module id = 2124
// module chunks = 0